import React, { useState } from 'react';
import { Button, Divider, Dialog, DialogActions, DialogTitle, DialogProps, DialogContent, TextField, Grid } from '@material-ui/core';
import Strapi from '../../services/strapi';

interface StrapiEmbedPopupProps extends DialogProps {
	open: boolean,
	onClose: (new_params: any) => void,
};

const StrapiEmbedPopup = (props: StrapiEmbedPopupProps) => {
	const [title, setTitle] = useState<string>("");
	const [body, setBody] = useState<string>("");

	return (
		<Dialog open={props.open} onClose={() => {
			props.onClose([]);
		}} fullWidth>
			<DialogTitle>
				Creation d'un embed
            </DialogTitle>
			<DialogContent>
				<Grid container direction="column">
					<p>Title:</p>
					<TextField name="title" onChange={(e) => {
						setTitle(e.target.value);
					}} />
					<p>Body:</p>
					<TextField fullWidth multiline rows={5} name="body" onChange={(e) => {
						setBody(e.target.value);
					}} />
					<Divider />
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => {
					Strapi.post("embeds", {}, {
						body,
						title,
					}).then(r => {
						props.onClose(r);
					});
				}}>Create</Button>
			</DialogActions>
		</Dialog>
	);
}

export default StrapiEmbedPopup;